import { render, staticRenderFns } from "./assessmentConf.vue?vue&type=template&id=c9431778&"
import script from "./assessmentConf.vue?vue&type=script&lang=js&"
export * from "./assessmentConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports